module.exports = __webpack_public_path__ + "static/media/tsukasa-aoi-icon.39c2303d.jpg";